import dynamic from 'next/dynamic';
import { TravelInsuranceWidgetProps } from './TravelInsuranceWidget.types';

export const TravelInsuranceWidgetMGP = dynamic<TravelInsuranceWidgetProps>(
  () => import('./TravelInsuranceWidget').then(module => module.TravelInsuranceWidget),
  { ssr: false }
);
